"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../../../utils/styles");

var _rcProgress = require("rc-progress");

function ProgressBar(_ref) {
  var type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["type"]);
  var theme = (0, _styles.useTheme)();
  var Component = type === 'circle' ? _rcProgress.Circle : _rcProgress.Line;
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    prefixCls: "hoi-poi-ui",
    strokeColor: theme.colors.primary,
    trailColor: theme.colors.placeholders
  }, props));
}

ProgressBar.defaultProps = {
  type: 'line',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeLinecap: 'round',
  strokeWidth: 0.555555555555556
};
var mixedType = process.env.NODE_ENV !== "production" ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]) : {};
process.env.NODE_ENV !== "production" ? ProgressBar.propTypes = {
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(['line', 'circle']),
  percent: _propTypes.default.oneOfType([mixedType, _propTypes.default.arrayOf(mixedType)]),
  strokeColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])), _propTypes.default.object]),
  strokeWidth: mixedType,
  style: _propTypes.default.object,
  trailColor: _propTypes.default.string,
  trailWidth: mixedType
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(ProgressBar);

exports.default = _default;